import Vue from 'vue';
import FormatterHelper from '@/scripts/helpers/formatter.helper.js'

Vue.filter('FormatPaymentMethod', (paymentMethod) => {
    return FormatterHelper.formatPaymentMethod(paymentMethod);
});